<template>
<div>
	<Loader :show="loading"></Loader>

	<div class="fullscreen" >
		<div class="head ">
			<div class="container">
				<div class="btn icon icon-close invert" @click="$router.push('/')" ></div>
				<h1>Iniciar traslado</h1>
				<!-- <h2>{{control.car.brand.title}} {{control.car.model}}</h2>
				<div class="brand" v-if="control.car.brand.logo" :style="{backgroundImage:`url(${API_URL+control.car.brand.logo.urlThumb})`}"></div> -->
			</div>
		</div>

		<div class="content">
			<div class="container">


				<div>

					<div class="d-flex align-items-end position-relative">

						<b-form-group label="Número de Chasis" class="mt-4 flex-grow-1">
							<b-form-input
								v-model="form.chassis_number"
								placeholder="Ingrese el número de chasis del vehículo a trasladar"
								:state="!validation.hasError('form.chassis_number')" 
							></b-form-input>
							<b-form-invalid-feedback>Ingrese el número de chasis del vehículo a trasladar</b-form-invalid-feedback>
						</b-form-group>

						<!-- <div @click="openSearch()" class="btn ml-1 btn-sm btn-outline-secondary">
							Buscar existente
						</div> -->
						<div @click="searchCars()" class="btn ml-1 btn-find">
							<i class="fa fa-search"></i>
						</div>
						
						<div @click="scanCar()" class="btn ml-1 btn-scan">
							<i class="fa fa-qrcode"></i>
						</div>

						<div class="selectable" v-if="showSelectable">
							<table class="table mt-2 mb-4" v-if="cars.length>0">
								<tr class="table-head">
									<td>Chasis</td>
									<td>Vehículo</td>
									<td>Cliente</td>
								</tr>
								<tr v-for="item of cars" :key="item.id" @click="selectCar(item)">
									<td>{{item.chassis_number}}</td>
									<td>
										<div class="tc">
											<span class="text-primary">
												<span v-if="item.brand && !item.brand.title">{{item.brand}}</span>
												<span v-if="item.brand.title">{{item.brand.title}}</span>
											</span>
											<span >{{item.model}}</span>
										</div>
									</td>
									<td>
										<div class="tc" v-if="item.client">
											<span class="text-primary">{{item.client.name}}</span>
											<span >{{item.client.business_name}}</span>
										</div>
									</td>
								</tr>
							</table>
							<div class="alert alert-warning mt-2" v-if="cars.length==0">
								No se han encontrado vehículos con el chasis ingresado
							</div>
						</div>
						<div v-if="showSelectable" class="selectable-backdrop" @click="showSelectable=false">

						</div>
					</div>
					


					<!-- <b-form-group label="Marca" class="mt-4">
						<v-select
							taggable
							v-model="form.brand"
							:options="brands"
							:clearable="false"
							class="v-select"		
						/>
						<b-form-invalid-feedback :state="!validation.hasError('form.brand')" >Ingrese la marca</b-form-invalid-feedback>
					</b-form-group>	 -->

					<b-form-group label="Marca" class="mt-4">
						<b-form-input
							v-model="form.brand"
							placeholder="Ingrese la marca del vehículo"
							:state="!validation.hasError('form.brand')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese la marca del vehículo</b-form-invalid-feedback>
					</b-form-group>


					<b-form-group label="Modelo" class="mt-4">
						<b-form-input
							v-model="form.model"
							placeholder="Ingrese el modelo del vehículo"
							:state="!validation.hasError('form.model')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese el modelo del vehículo</b-form-invalid-feedback>
					</b-form-group>
					
					<b-form-group label="Color" class="mt-4">
						<b-form-input
							v-model="form.color"
							placeholder="Ingrese el color del vehículo"
							:state="!validation.hasError('form.color')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese el color del vehículo</b-form-invalid-feedback>
					</b-form-group>
					
					
					<b-form-group label="Lugar de retiro" class="mt-4">
						
						<v-select
							taggable
							v-model="form.location"
							:options="locations"
							:clearable="false"
							class="v-select"
							
						/>
						<b-form-invalid-feedback :state="!validation.hasError('form.location')" >Ingrese el lugar de retiro</b-form-invalid-feedback>
					</b-form-group>	

					<!-- <b-form-group label="Lugar de retiro" class="mt-4">
						<b-form-input
							v-model="form.location"
							placeholder="Ingrese el lugar de retiro"
							:state="!validation.hasError('form.location')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese el lugar de retiro</b-form-invalid-feedback>
					</b-form-group>	 -->
					
					
					<b-form-group label="Firma" class="mt-4 mb-4">
						<div class="invalid-feedback d-block" v-if="validation.hasError('form.signature')">Ingrese la firma</div>					
						<SignatureInput v-model="form.signature"></SignatureInput>
					</b-form-group>

					<b-form-group label="Aclaración" class="mt-4">
						<b-form-input
							v-model="form.signatureClarification"
							placeholder="Ingrese la aclaración de la firma."
							:state="!validation.hasError('form.signatureClarification')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese la aclaración de la firma.</b-form-invalid-feedback>
					</b-form-group>


					<b-form-group label="Comentarios" class="mt-4">
						<textarea-autosize
						placeholder="Comentarios"
						v-model="form.comments"
						:min-height="30"
						:max-height="350"
						class="form-control"
						/>
					</b-form-group>

				</div>				
				
			</div>
		</div>
		<div class="footer">
			<div class="container">
				<div class="btn btn-block btn-primary" @click="save()">
					Iniciar traslado
				</div>
			</div>
		</div>
	</div>


	
	
	<!-- <ControlSuccess 
		v-if="control.step=='ControlSuccess'"
		:control="controlCreated"
	></ControlSuccess> -->

	<ReadCode ref="readCarCode" @readed="chassisReaded" />

</div>
</template>


<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import SignatureInput from '@/components/SignatureInput'
import ReadCode from './ReadCode'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'TransferStart',
	mixins:[mixins],
	components: {
		Loader,
		SignatureInput,
		ReadCode
	},
	data(){
		return{
			API_URL: process.env.VUE_APP_API_URL,
			loading: false,
			brands:[],
			showSelectable: false,
			touched :false,
			cars: [],
			form:{
				chassis_number: null,
				brand: null,
				model: null,
				color: null,
				location: null,
				signature: null,
				signatureClarification: null,
				comments: null,
			},
			// locations:['Rondeau', 'Propios', 'Carrasco', 'Chevrolet Montevideo', 'Galicia','Emancipación']
			locations:['Rondeau', 'CarOne', 'Carrasco', 'Chevrolet Montevideo', 'Shopping de autos','Emancipación', 'Lync & Co']
		}
	},
	validators: {
		'form.chassis_number': function (value) {
			return Validator.value(value).required();
		},
		'form.brand': function (value) {
			return Validator.value(value).required();
		},
		'form.signatureClarification': function (value) {
			return Validator.value(value).required();
		},
		'form.model': function (value) {
			return Validator.value(value).required();
		},
		'form.color': function (value) {
			return Validator.value(value).required();
		},
		'form.location': function (value) {
			return Validator.value(value).required();
		},
		'form.signature': function (value) {
			return Validator.value(value).required();
		},
	},
	beforeMount(){
		this.fetchData();
	},
	methods:{
		scanCar(){
			this.$refs.readCarCode.open()
		},

		chassisReaded(chassis_number){
			this.loading = true
			this.$apollo.query({
				query: gql`query ($chassis_number: String!) {
					car (chassis_number: $chassis_number) {
						id
						chassis_number
						brand{ id title}
						model
						color{ title }
					}
				}`,
				variables: {
					chassis_number: chassis_number
				},
				fetchPolicy: 'no-cache'
			})
			.then(({data}) => {
				if(!data.car){
					this.$toast.error('No se ha encontrado un vehículo con ese código')
				}else{
					this.form.chassis_number = data.car.chassis_number
					this.form.brand = data.car.brand.title
					this.form.model = data.car.model
					this.form.color = data.car.color.title
				}
				this.loading = false
			})
		},


		fetchData(){
			this.$apollo.query({
				query: gql`query  {
					car_brands   {
						id
						title
						models{
							title
						}
					}
				}`,
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.loading = false
				this.brands = data.data.car_brands.map(brand=> brand.title)
			})
		},
		
		async searchCars(){
			if(this.form.chassis_number){
				this.touched = true
				this.loading = true

				await this.$apollo.query({
					query: gql`query ($chassis_number: String!) {
						carsAll (chassis_number: $chassis_number) {
							id
							chassis_number
							model
							brand{
								id
								title
							}
							client{
								name
								business_name
							}
							color { title}
						}
						transfer_requestsAll(chassis_number: $chassis_number)  {
							id
							client{
								name
								business_name
							}
							brand
							model
							color
							chassis_number
						}
					}`,
					variables: {
						chassis_number: this.form.chassis_number,
					},
					fetchPolicy: 'no-cache'
				})
				.then((data) => {
					this.loading = false
					if(data.data.carsAll.length > 0) {
						this.cars = data.data.carsAll
					}
					if(data.data.transfer_requestsAll.length > 0) {
						this.cars = data.data.transfer_requestsAll
					}
					this.showSelectable = true
				})
			}
		},

		selectCar(car){
			this.form.chassis_number = car.chassis_number
			this.form.brand = (car.brand.title) ? car.brand.title : car.brand
			this.form.model = car.model
			this.form.color = (car.color.title) ? car.color.title : car.color
			this.showSelectable = false
			
		},


		async save(){
			if(!this.loading && await this.checkValidation() ) {
				// this.loading = true
				let dataInput = {
					type: 				'CHECKOUT',
					chassis_number: 	this.form.chassis_number,
					brand: 				this.form.brand,
					model: 				this.form.model,
					color: 				this.form.color,
					location: 			this.form.location,
					signature: 			this.form.signature,
					signatureClarification: this.form.signatureClarification,
					comments: 			this.form.comments,
				}
				this.$apollo.mutate({
					mutation: gql`mutation ( $data:ControlTransferInput! ){
						controlTransfer( data: $data) {
							id
							created_at
						}
					}`,
					variables: {
						data: dataInput
					}
				})
				.then((data) => {
					this.controlCreated = data.data.controlTransfer
					this.$toast.success('Traslado iniciado correctamente')
					this.$router.push('/')
				})
				.catch( (error) => {
					this.parseGQLErrors(error)
					this.loading = false
				})
			}
		}
	}
	
}
</script>

<style scoped>
.selectable{
	width:410px;
    position: absolute;
	top: 80px;
    left: 5px;
    background: #fff;
    z-index: 1000;
	border-radius: 0px 0px 4px 4px;
    padding: 8px;
	-webkit-box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.33);
	-moz-box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.33);
	box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.33);
}
.selectable-backdrop{
	width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    right: 0px;
    position: fixed;
    background: #f3f3f350;
    bottom: 0px;
    z-index: 10;
}

.btn-scan{
	height: 38px;
    border-radius: 4px;
    font-size: 22px;
    display: flex;
    align-items: center;
    background: #28a745;
    border: #28a745;
    color: #fff;
}
.btn-find{
	height: 38px;
    border-radius: 4px;
    font-size: 22px;
    display: flex;
    align-items: center;
    background: #28a745;
    border: #28a745;
    color: #fff;
}


</style>
